// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"78455600","289":"514584b2","633":"514584b2"}[chunkId] + ".chunk.css";
};